import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fuelSelect", "container"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const isElectric = this.fuelSelectTarget.value === "electric"

    if (isElectric) {
      this.containerTargets.forEach(container => {
        container.classList.add("hidden")
        this.disableAndClearInputs(container)
      })
    } else {
      this.containerTargets.forEach(container => {
        container.classList.remove("hidden")
        this.enableInputs(container)
      })
    }
  }

  disableAndClearInputs(container) {
    container.querySelectorAll("input, select").forEach(input => {
      input.disabled = true
      input.value = ""
      input.dispatchEvent(new Event("change"))
    })
  }

  enableInputs(container) {
    container.querySelectorAll("input, select").forEach(input => {
      input.disabled = false
    })
  }
}
